import { render, staticRenderFns } from "./AppointmentDetail.vue?vue&type=template&id=eaebb04a&scoped=true&"
import script from "./AppointmentDetail.vue?vue&type=script&lang=ts&"
export * from "./AppointmentDetail.vue?vue&type=script&lang=ts&"
import style0 from "./AppointmentDetail.vue?vue&type=style&index=0&id=eaebb04a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eaebb04a",
  null
  
)

export default component.exports